function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useCallback as h, useRef as m } from "react";
import { FocusableMode as M, isFocusableElement as b } from '../utils/focus-management.js';
import { isMobile as y } from '../utils/platform.js';
import { useDocumentEvent as c } from './use-document-event.js';
import { useIsTopLayer as L } from './use-is-top-layer.js';
import { useLatestValue as g } from './use-latest-value.js';
import { useWindowEvent as H } from './use-window-event.js';
var d = 30;
function F(E, p, C) {
  var u = L(E, "outside-click"),
    f = g(C),
    s = h(function (e, o) {
      if (e.defaultPrevented) return;
      var r = o(e);
      if (r === null || !r.getRootNode().contains(r) || !r.isConnected) return;
      var T = function i(n) {
        return typeof n == "function" ? i(n()) : Array.isArray(n) || n instanceof Set ? n : [n];
      }(p);
      var _iterator = _createForOfIteratorHelper(T),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var i = _step.value;
          if (i === null) continue;
          var n = i instanceof HTMLElement ? i : i.current;
          if (n != null && n.contains(r) || e.composed && e.composedPath().includes(n)) return;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return !b(r, M.Loose) && r.tabIndex !== -1 && e.preventDefault(), f.current(e, r);
    }, [f]),
    l = m(null);
  c(u, "pointerdown", function (t) {
    var e, o;
    l.current = ((o = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : o[0]) || t.target;
  }, !0), c(u, "mousedown", function (t) {
    var e, o;
    l.current = ((o = (e = t.composedPath) == null ? void 0 : e.call(t)) == null ? void 0 : o[0]) || t.target;
  }, !0), c(u, "click", function (t) {
    y() || l.current && (s(t, function () {
      return l.current;
    }), l.current = null);
  }, !0);
  var a = m({
    x: 0,
    y: 0
  });
  c(u, "touchstart", function (t) {
    a.current.x = t.touches[0].clientX, a.current.y = t.touches[0].clientY;
  }, !0), c(u, "touchend", function (t) {
    var e = {
      x: t.changedTouches[0].clientX,
      y: t.changedTouches[0].clientY
    };
    if (!(Math.abs(e.x - a.current.x) >= d || Math.abs(e.y - a.current.y) >= d)) return s(t, function () {
      return t.target instanceof HTMLElement ? t.target : null;
    });
  }, !0), H(u, "blur", function (t) {
    return s(t, function () {
      return window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null;
    });
  }, !0);
}
export { F as useOutsideClick };